import { isRestrictedDate } from '../../utils/date-time-utilities';
export var validateDate = function validateDate(futureSelectedDate, futureFormattedDate, calendarOptions, dateFormatting, required) {
  if (futureSelectedDate && !isNaN(futureSelectedDate.getTime())) {
    if (isRestrictedDate(futureSelectedDate, calendarOptions)) {
      return dateFormatting.isOutOfBoundsErrorMessage;
    }
  } else if (futureFormattedDate) {
    return dateFormatting.invalidInputErrorMessage;
  } else if (required && !futureSelectedDate) {
    return dateFormatting.isRequiredErrorMessage;
  }

  return '';
};
//# sourceMappingURL=validateDate.js.map
